import { render, staticRenderFns } from "./tradeFollow.vue?vue&type=template&id=aa1fcf58"
import script from "./tradeFollow.vue?vue&type=script&lang=js"
export * from "./tradeFollow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports